import { render } from "./LoadingIcon.vue?vue&type=template&id=4a7c0900&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"

import "./LoadingIcon.vue?vue&type=style&index=0&id=4a7c0900&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7c0900"]])

export default __exports__